import styled from '@emotion/styled';

export const TitleContainer = styled.div`
  position: relative;
  top: 20px;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
